import CacheStore from 'bz-utilities/modules/stores/cached-map-store';
import { computed } from 'mobx';
import { createTransformer } from 'mobx-utils';
import type { RoomResponse } from 'tm3-core/api.dtos';

class RoomsStore extends CacheStore<RoomResponse> {
  constructor() {
    super('rooms');
  }

  public search(searchTerm: string = '', locationId: number): RoomResponse[] {
    if (!searchTerm) return this.ByLocation(locationId);
    const lowerSearchTerm = searchTerm.toLowerCase();
    return this.ByLocation(locationId).filter((room) =>
      room?.description?.toLowerCase().includes(lowerSearchTerm)
    );
  }

  @computed
  get Current() {
    return this.All.filter((x) => x.status);
  }

  ByLocation = createTransformer((locationId: number) =>
    this.Current.filter((x) => x.locationId === locationId)
  );
}
export default RoomsStore;
